import React from 'react';
import { Plus, Eye, Edit, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { useNavigate } from 'react-router-dom';
export function ManagePackages() {
  const navigate = useNavigate();
  const packages = [{
    id: 1,
    position: 1,
    name: '3-Class Renewal Package (select your own courses-9 hours)',
    type: 'Generic package',
    price: '$49.95',
    publish: 'Yes'
  }, {
    id: 2,
    position: 5,
    name: '#1 8-Class Salesperson Renewal Package (Preset-24 hours)',
    type: 'Preset package',
    price: '$89.95',
    publish: 'Yes'
  }, {
    id: 3,
    position: 3,
    name: '6-Class Salesperson Renewal Package (select your own courses-18 hours)',
    type: 'Generic package',
    price: '$69.95',
    publish: 'Yes'
  }, {
    id: 4,
    position: 2,
    name: '3-Class Broker Management Clinic (Preset with BMC 1-2-3 for 9 hours',
    type: 'Preset package',
    price: '$54.95',
    publish: 'Yes'
  }, {
    id: 5,
    position: 8,
    name: '10-class Broker Renewal Package (Preset-30 hours with NAR Ethics)',
    type: 'Preset package',
    price: '$104.95',
    publish: 'Yes'
  }, {
    id: 6,
    position: 3,
    name: '6-Class FIRST TIME Renewal Package (Preset -18 Hours)',
    type: 'Preset package',
    price: '$69.95',
    publish: 'Yes'
  }, {
    id: 7,
    position: 5,
    name: '#2 8-Class Salesperson Renewal Package (Preset-24 hours with NAR Ethics)',
    type: 'Preset package',
    price: '$89.95',
    publish: 'Yes'
  }, {
    id: 8,
    position: 2,
    name: '3-Class Property Management BMC (Preset with BMC 1-2-3B for 9 hours)',
    type: 'Preset package',
    price: '$54.95',
    publish: 'Yes'
  }, {
    id: 9,
    position: 9,
    name: '10-Class Renewal Package for Property Management Brokers (Preset 30-hours with NAR Ethics and BMC #3B)',
    type: 'Preset package',
    price: '$104.95',
    publish: 'Yes'
  }];
  return <div className="space-y-4" data-id="element-1256" data-mp="j7qhe2vmaqgo">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1257" data-mp="ea71yzn6o7n5">Manage Packages</h1>

      <div data-id="element-1258" data-mp="ecb2r8pscqj7">
        <p className="text-sm font-medium text-slate-700 mb-2" data-id="element-1259" data-mp="ec1m4bqmrvq6">Packages</p>
        <Button size="sm" variant="secondary" className="gap-1.5 border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/packages/add')} data-id="element-1260" data-mp="9cyh2ranhpi7">
          <Plus className="h-3.5 w-3.5 text-green-600" data-id="element-1261" data-mp="x8jbimi0bjj9" />
          Add
        </Button>
      </div>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1262" data-mp="saht83seno8u">
        <div className="overflow-x-auto" data-id="element-1263" data-mp="s85ctv2aplxw">
          <table className="w-full text-sm text-left" data-id="element-1264" data-mp="1ppn8xq90pl8j">
            <thead className="bg-slate-800 text-white font-medium" data-id="element-1265" data-mp="1pr6tht1piig4">
              <tr data-id="element-1266" data-mp="1kx2ld6gpg4dg">
                <th className="px-3 py-3 border-r border-slate-700 text-center w-20" data-id="element-1267" data-mp="1kwkgjlfz8htx">
                  Position
                </th>
                <th className="px-3 py-3 border-r border-slate-700" data-id="element-1268" data-mp="1x8d1k63m11l5">Name</th>
                <th className="px-3 py-3 border-r border-slate-700 w-32" data-id="element-1269" data-mp="1xapq523via76">
                  Package Types
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-20" data-id="element-1270" data-mp="277lucvmqoa5x">
                  Price
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-16" data-id="element-1271" data-mp="2b7w66ox7pusp">
                  Publish
                </th>
                <th className="px-3 py-3 text-center w-32" data-id="element-1272" data-mp="2g5e7pu8wh7qo">
                  <div data-id="element-1273" data-mp="2kzs6m6mrtx03">Actions</div>
                  <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-1274" data-mp="2l0tjmgncktkg">
                    View | Edit | Delete
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-1275" data-mp="2uutwx5ss9549">
              {packages.map(pkg => <tr key={pkg.id} className="hover:bg-slate-50" data-id="element-1276" data-mp="2yvvyvue33v9x">
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-1277" data-mp="gfqyex3aziz">
                    {pkg.position}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200" data-id="element-1278" data-mp="9a17a2owkoui">
                    {pkg.name}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 text-slate-600" data-id="element-1279" data-mp="57xlak4ly1uz">
                    {pkg.type}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-1280" data-mp="3doiw86gsv50q">
                    {pkg.price}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-1281" data-mp="3mop67idahmv5">
                    {pkg.publish}
                  </td>
                  <td className="px-3 py-2.5 text-center" data-id="element-1282" data-mp="3hp2u5c976cnx">
                    <div className="flex items-center justify-center gap-2" data-id="element-1283" data-mp="11yg9fomxrcof">
                      <button title="View" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/packages/view/${pkg.id}`)} data-id="element-1284" data-mp="120j970dw4k6c">
                        <Eye className="h-4 w-4" data-id="element-1285" data-mp="19jacl59xmqaa" />
                      </button>
                      <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/packages/edit/${pkg.id}`)} data-id="element-1286" data-mp="vizkjywvz5nj">
                        <Edit className="h-4 w-4" data-id="element-1287" data-mp="1o7n8k290s94s" />
                      </button>
                      <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-1288" data-mp="1t4wxlgshyis3">
                        <Trash2 className="h-4 w-4" data-id="element-1289" data-mp="1jfvirtxou7fp" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <div className="text-sm text-blue-600 flex items-center gap-1 mt-2" data-id="element-1290" data-mp="2bxhncpcwg7ro">
        <button className="hover:underline" data-id="element-1291" data-mp="2lt81hd7b2wny">&lt;&lt; previous</button>
        <span className="text-slate-400" data-id="element-1292" data-mp="2lqc17i7zjvwc">|</span>
        <span className="text-slate-900 font-medium" data-id="element-1293" data-mp="2gumy54wrbwva">1</span>
        <span className="text-slate-400" data-id="element-1294" data-mp="2bu8r9q6w6syu">|</span>
        <button className="hover:underline" data-id="element-1295" data-mp="2bsxnvrhczn89">next &gt;&gt;</button>
      </div>
    </div>;
}